import countries from "i18n-iso-countries";

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
export const getCountries = () => {
  const pairs: { key: string } = countries.getNames("en", {
    select: "official",
  });
  return Object.values(pairs).sort((a, b) => a.localeCompare(b));
};
